/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuntimeListInfo
 */
export interface RuntimeListInfo {
    /**
     * 
     * @type {string}
     * @memberof RuntimeListInfo
     */
    runtimeId: string;
    /**
     * 
     * @type {string}
     * @memberof RuntimeListInfo
     */
    name: string;
}

export function RuntimeListInfoFromJSON(json: any): RuntimeListInfo {
    return RuntimeListInfoFromJSONTyped(json, false);
}

export function RuntimeListInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeListInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'runtimeId': json['runtimeId'],
        'name': json['name'],
    };
}

export function RuntimeListInfoToJSON(value?: RuntimeListInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'runtimeId': value.runtimeId,
        'name': value.name,
    };
}


